import React, { Component } from 'react';
import { connect } from 'react-redux';
import FormModal from 'components/shared/modal/FormModal';
import checkCirclePng from 'images/check-circle.png';
import { getShowChangeOrderRequestConfirmation } from 'components/admin/work-orders/details/change-order-quotes/store/selectors';
import { setShowChangeOrderQuoteRequestConfirmation } from 'components/admin/work-orders/details/change-order-quotes/store/actions';
import ConfirmationPanel from 'components/shared/confirmation/ConfirmationPanel';

class ChangeOrderQuoteConfirmationModal extends Component {
  handleConfirmation = () => {
    this.props.dispatch(setShowChangeOrderQuoteRequestConfirmation());
  };

  render() {
    return (
      <div>
        <FormModal show={this.props.showConfirmation} showHeader={false}>
          <ConfirmationPanel
            image={checkCirclePng}
            firstLine="Thank you!"
            lines={[this.props.message]}
            buttons={[
              <input
                type="button"
                className="btn button button-orange"
                value="Continue"
                onClick={this.handleConfirmation}
              />,
            ]}
          />
        </FormModal>
      </div>
    );
  }
}

export default connect((state) => {
  return {
    showConfirmation: getShowChangeOrderRequestConfirmation(state),
  };
})(ChangeOrderQuoteConfirmationModal);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/change-order-quotes/ChangeOrderQuoteConfirmationModal.js